import { WSConnection, WsConnectionStatus } from '@hakimo-ui/hakimo/types';
import { createContext, useContext } from 'react';

const defaultValue: WSConnection = {
  connectionState: {
    status: WsConnectionStatus.PENDING,
    isDuplicateSession: false,
  },
};

export const ScanWsContext = createContext(defaultValue);

export function useScanWs() {
  const httpClient = useContext(ScanWsContext);
  return httpClient;
}
